import {
    SAVE_CONSIGNMENTRETURN_ORDER,
    SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS,
    SAVE_CONSIGNMENTRETURN_ORDER_FAILURE,
    RESET_CONSIGNMENT_RETURN_ORDER
} from '../actions';

const initialState = {
    myCaseRef: '',
    statusCode: '',
    statusMessage: '',
    loading: false,
    data:{},
    saveConsignmentReturn: {
        data: {},
        message: '',
        statusCode: '',
    },
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const consignmentReturnOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CONSIGNMENTRETURN_ORDER:
            return {
                ...state,
                updateConsignmentLoading: true,
            };
        case SAVE_CONSIGNMENTRETURN_ORDER_SUCCESS:
            return {
                ...state,
                myCaseRef: action.data.myCaseRef,
                statusCode: '200',
                statusMessage: action.data.statusMessage,
                updateConsignmentLoading: false,
                data:action.data,
                saveConsignmentReturn: {
                    data: action.data,
                    statusCode: '200',
                },
            };
        case SAVE_CONSIGNMENTRETURN_ORDER_FAILURE:
            return {
                ...state,
                // myCaseRef: action.data.myCaseRef,
                statusCode: '422',
                statusMessage: action.data.message,
                updateConsignmentLoading: false,
                data:{},
                saveConsignmentReturn: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
            };
        case RESET_CONSIGNMENT_RETURN_ORDER:
            return initialState;

        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentReturnOrderReducer',
        storage: storage,
        //transforms: [SetTransform],
    },
    consignmentReturnOrderReducer
);
